/**
 * Admin guide 2 — sending: what goes out each minute, what is checked
 * before every send, and when a draft waits for a person.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { Flow, Points, V } from '../guide-ui';

export const SendingSection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <div className="flex flex-col gap-3">
    <Flow
      stamp="One draft, from due to sent"
      steps={[
        { when: 'Its time comes', what: 'Due', how: 'Earliest first in the minute.' },
        { when: 'Before each send', what: 'Checked again', how: 'Kill switch, halt, daily cap, group stopped, texts · senders · list ready.' },
        { when: 'SMSWiser', what: 'Sent', how: 'The drop goes out; its stats are read later.' },
      ]}
    />
    <Points
      items={[
        <>Each minute the engine sends the drafts due now, at most <V>{s.maxSendsPerMinute}</V> a minute per country — a drop every 2 minutes is easy, a burst simply finishes the next minute.</>,
        <>A draft more than <V>{s.lateToleranceMin} min</V> late is never sent blind: it waits for a person (missed).</>,
        <>A draft still “sending” after <V>{s.stuckSendingMin} min</V> is checked with SMSWiser before anything else happens.</>,
        <><b>Send at its time</b> = the engine sends each minute · <b>Schedule in SMSWiser</b> = drafts are submitted ahead with their time.</>,
      ]}
    />
  </div>
);
